<div *ngIf="reactiveFormGroup$ | async as formGroup" [formGroup]="reactiveFormGroupComponent?.getReactiveFormGroup()">
  <app-odata-typeahead-search
    label="Designated Unit"
    i18n-label
    [odataFunction]="odataFunction"
    placeHolder="Search by unit name or ID"
    i18n-placeHolder
    [disabled]="!!selectedDesignatedUnit"
    [searchedProperties]="['unitName', 'clientUnitId']"
    [customItemTemplate]="lookAheadItemTemplate"
    [popperClass]="'look-ahead-popper-full-width'"
    [hasErrors]="hasErrors$ | async"
    (lookAheadSelected)="designatedUnitSelected.emit($event)" />
  <lib-reactive-form-hint-text *ngIf="!!hintText" [hintText]="hintText" />
  <lib-reactive-form-general-error
    [parentFormGroupComponent]="reactiveFormGroupComponent"
    [reactiveFormItemComponent]="this"
    [required]="required"
    [disabled]="disableInput$ | async"
    [performValidationWhenDisabled]="performValidationWhenDisabled"
    (hasError)="connectToHasErrors($event)" />
  <input hidden [formControlName]="inputName" [id]="id" [name]="inputName" />
</div>

<ng-template #lookAheadItemTemplate let-designatedUnit
  >{{ designatedUnit.unitName }} ({{ designatedUnit.clientUnitId }})
</ng-template>
